import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA014_Request,
  IAPI_STA014_Response,
  IAPI_STA018_Request,
  IAPI_STA018_Response,
  IAPI_STA023_Request,
  IAPI_STA023_Response,
} from "../../../type/apiType";

// 加入登録手続き一覧参照
const httpAPI_STA018 = async (
  param: IAPI_STA018_Request
): Promise<IAPI_STA018_Response> => {
  let res = await http.post(ApiUrl.API_STA018, {
    ...param,
  });

  return res.data;
};

// 職員情報削除
const httpAPI_STA014 = async (
  param: IAPI_STA014_Request
): Promise<IAPI_STA014_Response> => {
  let res = await http.post(ApiUrl.API_STA014, {
    ...param,
  });

  return res.data;
};

// 加入登録手続き申請更新
const httpAPI_STA023 = async (
  param: IAPI_STA023_Request
): Promise<IAPI_STA023_Response> => {
  let res = await http.post(ApiUrl.API_STA023, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA018, httpAPI_STA014, httpAPI_STA023 };
